import { render, staticRenderFns } from "./PlaygroundTreeEditorV2.vue?vue&type=template&id=0ab884ed"
import script from "./PlaygroundTreeEditorV2.js?vue&type=script&lang=js&external"
export * from "./PlaygroundTreeEditorV2.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
